import * as React from 'react';
import {useDispatch} from 'react-redux';
import {ActionCreator, ActionCreatorsMapObject, bindActionCreators} from 'redux';

interface UseActionCreators {
    <A, C extends ActionCreator<A>>(actionCreator: C): C;
    <A, M extends ActionCreatorsMapObject<A>>(actionCreators: M): M;
}

export const useActionCreators: UseActionCreators = (creators: unknown) => {
    const dispatch = useDispatch();

    return React.useMemo(
        () => bindActionCreators(creators as never, dispatch),
        // без creators, т.к. action-creators не изменяются
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch],
    );
};
